import { styled, TableCell } from "@material-ui/core";

export const CustomTableCell = styled(TableCell)(() => ({
  color: "inherit",
}));

export const MultiLineTableCell = styled(CustomTableCell)(() => ({
  padding: "12px",
}));

export const SingleLineTableCell = styled(MultiLineTableCell)(() => ({
  whiteSpace: "nowrap",
}));
